import React from 'react';
import { PropTypes } from 'prop-types';
import { useState } from 'react';
import './documents.css';
import T from 'i18n-react';

const DocumentIconButton = (props) => {
    const [hover, setHover] = useState(false);
    
    const onMouseOver = (event) => {
        if (!hover) {
            setHover(true);
        }
    };

    const onMouseLeave = (event) => {
        if (hover) {
            setHover(false);
        }
    };

    const onButtonClick = (event) => {
        if (props.onClick) {
            props.onClick(event);
        }
    };

    const UploadIcon = ({ color }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <g clipPath="url(#clip0_14819_9339)">
                <path d="M28.7188 15.1417C27.7271 10.1105 23.3083 6.33337 18 6.33337C13.7854 6.33337 10.125 8.72504 8.30208 12.225C3.9125 12.6917 0.5 16.4105 0.5 20.9167C0.5 25.7438 4.42292 29.6667 9.25 29.6667H28.2083C32.2333 29.6667 35.5 26.4 35.5 22.375C35.5 18.525 32.5104 15.4042 28.7188 15.1417ZM20.9167 19.4584V25.2917H15.0833V19.4584H10.7083L18 12.1667L25.2917 19.4584H20.9167Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_14819_9339">
                    <rect width="35" height="35" fill="white" transform="translate(0.5 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );

    const ManageIcon = ({ color }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="36" viewBox="0 0 28 36" fill="none">
            <g clipPath="url(#clip0_14560_19205)">
                <path d="M18.375 0.5V9.25H27.125L18.375 0.5ZM16.1875 9.25V0.5H4.15625C2.34404 0.5 0.875 1.96904 0.875 3.78125V32.2188C0.875 34.0303 2.34404 35.5 4.15625 35.5H23.8438C25.656 35.5 27.125 34.031 27.125 32.2188V11.4375H18.4365C17.165 11.4375 16.1875 10.46 16.1875 9.25Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_14560_19205">
                    <rect width="26.25" height="35" fill="white" transform="translate(0.875 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );

    var labelContext = props.labelContext || {};
    var isEnabled = props.isEnabled !== false;

    var iconColor = '#007C10';
    var textColor = '#4F4C4D';
    var buttonClassName = 'document-button-width';
    if (isEnabled) {
        buttonClassName += hover ? " documentsHover" : " documentsNoHover";
        iconColor = hover ? '#FFF' : '#007C10';
        textColor = hover ? '#FFF' : '#4F4C4D';
    } else {
        buttonClassName += " documentsDisabled";
        iconColor = '#3F3F3F';
    }

    return (              
        <div onMouseOver={onMouseOver} onMouseLeave={onMouseLeave} className={buttonClassName} onClick={onButtonClick} >
            <div className='documents-button-wrapper'>
                <div className='documents-icon'>
                    {props.iconKey === 'Upload' ? <UploadIcon color={iconColor} /> : <ManageIcon color={iconColor} />}
                </div>
                <div className='documents-icon-label' style={{ color: textColor }}>{T.translate(props.label, labelContext)}</div>
                {/* <div className='documents-icon-chevron'> {Chevron({ color: iconColor })}</div> */}
            </div>
        </div>
    );       
};

DocumentIconButton.propTypes = {
    iconKey: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    labelContext: PropTypes.object,
    isEnabled: PropTypes.bool,
    layoutType: PropTypes.string.isRequired,
    onClick: PropTypes.func
};

export default DocumentIconButton;